import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  bm: {
    // Menu Items
    menu: {
      guide: 'Panduan',
      checklist: 'Checklist Harian',
      dashboard: 'Dashboard',
      analytics: 'Analytics',
      strategy: 'Pembina Strategi',
      achievements: 'Pencapaian',
      tools: 'Tools',
      journal: 'Journal',
      calculators: 'Kalkulator',
      ai: 'AI Analisis',
      education: 'Pendidikan',
      marketing: 'Marketing Angle',
      settings: 'Tetapan',
      polymarket: 'Polymarket Prediction',
    },
    // Dashboard
    dashboard: {
      title: 'Gambaran Trading',
      todayPnl: 'P/L Hari Ini',
      weeklyPnl: 'P/L Minggu Ini',
      monthlyPnl: 'P/L Bulan Ini',
      winRate: 'Win Rate',
      totalTrades: 'Jumlah Trades',
      avgWin: 'Purata Win',
      avgLoss: 'Purata Loss',
      profitFactor: 'Profit Factor',
      bestPair: 'Pair Terbaik',
      worstPair: 'Pair Terburuk',
      riskReward: 'Risk:Reward',
      drawdownStatus: 'Status Drawdown',
      drawdownSafe: 'Selamat',
      drawdownWarning: 'Berhati-hati',
      drawdownDanger: 'Bahaya!',
      noTrades: 'Tiada trade hari ini',
      recentTrades: 'Trade Terkini',
      weeklyChart: 'Prestasi Mingguan',
      exportPdf: 'Export PDF',
      pdfGenerating: 'Menjana PDF...',
      pdfReady: 'PDF Siap!',
    },
    // Analytics
    analytics: {
      title: 'Analisis Trading',
      sessionAnalysis: 'Analisis Sesi',
      emotionAnalysis: 'Analisis Emosi',
      pairAnalysis: 'Analisis Pair',
      equityCurve: 'Keluk Ekuiti',
      riskHeatmap: 'Peta Risiko',
      bestSession: 'Sesi Terbaik',
      worstSession: 'Sesi Terburuk',
      bestMood: 'Mood Terbaik',
      worstMood: 'Mood Terburuk',
      recommendation: 'Cadangan',
      noData: 'Data tidak mencukupi untuk analisis',
      asia: 'Asia',
      london: 'London',
      newyork: 'New York',
      overlap: 'Overlap',
    },
    // Achievements
    achievements: {
      title: 'Pencapaian',
      subtitle: 'Kumpul badge dan capai milestone!',
      unlocked: 'Terbuka',
      locked: 'Terkunci',
      progress: 'Kemajuan',
      allBadges: 'Semua Badge',
      journalBadges: 'Journal',
      streakBadges: 'Streak',
      disciplineBadges: 'Disiplin',
      profitBadges: 'Profit',
      accuracyBadges: 'Ketepatan',
      recentUnlocks: 'Baru Terbuka',
      noBadges: 'Belum ada badge',
    },
    // Journal
    journal: {
      title: 'Trading Journal',
      addTrade: 'Tambah Trade',
      editTrade: 'Edit Trade',
      pair: 'Pair',
      type: 'Jenis',
      buy: 'BUY',
      sell: 'SELL',
      result: 'Hasil (USD)',
      date: 'Tarikh',
      session: 'Sesi',
      mood: 'Mood',
      notes: 'Nota',
      noTrades: 'Tiada trade dalam jurnal',
      deleteConfirm: 'Padam trade ini?',
      importStatement: 'Import Statement',
      exportCsv: 'Export CSV',
    },
    // Moods
    moods: {
      tenang: 'Tenang',
      fokus: 'Fokus',
      takut: 'Takut',
      tamak: 'Tamak',
      revenge: 'Revenge',
      bosan: 'Bosan',
    },
    // Sessions
    sessions: {
      asia: 'Asia',
      london: 'London',
      ny: 'New York',
    },
    // Calculators
    calculators: {
      title: 'Kalkulator',
      lotSize: 'Kalkulator Lot',
      pipValue: 'Nilai Pip',
      compounding: 'Compounding',
      breakeven: 'Break-Even',
      riskReward: 'Risk:Reward',
      // Lot Calculator
      accountBalance: 'Baki Akaun',
      riskPercent: 'Risiko (%)',
      stopLoss: 'Stop Loss (pips)',
      lotResult: 'Saiz Lot',
      // Compounding
      initialCapital: 'Modal Awal',
      monthlyReturn: 'Pulangan Bulanan (%)',
      months: 'Bulan',
      finalAmount: 'Jumlah Akhir',
      totalProfit: 'Jumlah Profit',
      calculate: 'Kira',
    },
    // AI Chat
    aiChat: {
      title: 'Fira AI',
      placeholder: 'Tanya apa-apa tentang trading...',
      send: 'Hantar',
      thinking: 'Sedang berfikir...',
      newChat: 'Chat Baru',
      clearHistory: 'Padam Sejarah',
      suggestions: 'Cadangan Soalan',
      analyzeXau: 'Analisa XAU/USD',
      analyzeEur: 'Analisa EUR/USD',
      checkSession: 'Check Sesi',
      reviewSetup: 'Review Setup',
      todayAnalysis: 'Analisa Hari Ini',
      weekReview: 'Review Minggu',
      whatWrong: 'Apa Yang Salah?',
    },
    // Education
    education: {
      title: 'Pendidikan Trading',
      basics: 'Asas Trading',
      technical: 'Analisis Teknikal',
      fundamental: 'Analisis Fundamental',
      psychology: 'Psikologi Trading',
      riskManagement: 'Pengurusan Risiko',
      articles: 'Artikel',
      videos: 'Video',
      comingSoon: 'Akan Datang',
    },
    // Checklist
    checklist: {
      title: 'Checklist Harian',
      completed: 'Selesai!',
      streak: 'Streak',
      days: 'hari',
      items: {
        news: 'Semak kalendar ekonomi untuk berita high-impact',
        review: 'Review trades semalam & pelajaran',
        target: 'Tetapkan target profit & had kerugian harian',
        risk: 'Sahkan risiko per trade (peraturan 1-2%)',
        mental: 'Semakan mental - Adakah saya bersedia untuk trade?',
        levels: 'Kenalpasti key support/resistance',
        session: 'Semak sesi trading aktif (Asia/London/NY)',
      },
    },
    // Weekly Report
    weeklyReport: {
      title: 'Laporan Mingguan',
      period: 'Tempoh',
      totalTrades: 'Jumlah Trade',
      winTrades: 'Trade Menang',
      lossTrades: 'Trade Kalah',
      winRate: 'Win Rate',
      totalPnl: 'Jumlah P/L',
      bestPair: 'Pair Terbaik',
      worstPair: 'Pair Terburuk',
      moodAnalysis: 'Analisis Mood',
      sessionAnalysis: 'Analisis Sesi',
      sendEmail: 'Hantar Email',
      emailSent: 'Email dihantar!',
      emailFailed: 'Gagal hantar email',
    },
    // PDF Export
    pdfExport: {
      title: 'Export Laporan PDF',
      generating: 'Menjana PDF...',
      download: 'Muat Turun PDF',
      include: 'Sertakan dalam laporan:',
      summary: 'Ringkasan Trading',
      trades: 'Senarai Trade',
      analytics: 'Analisis',
      charts: 'Carta',
    },
    // Header
    header: {
      title: 'Fira Smart Desk AI',
      subtitle: 'Built to analyze. Designed to decide.',
      usdMyr: 'USD / MYR',
    },
    // Bottom Nav
    bottomNav: {
      tools: 'Tools',
      journal: 'Journal',
      premium: 'Signal',
      badges: 'Badge',
      menu: 'Menu',
    },
    // Common Buttons
    buttons: {
      save: 'Simpan',
      cancel: 'Batal',
      delete: 'Padam',
      edit: 'Edit',
      add: 'Tambah',
      close: 'Tutup',
      submit: 'Hantar',
      clear: 'Kosongkan',
      reset: 'Reset',
      search: 'Cari',
      filter: 'Tapis',
      export: 'Eksport',
      import: 'Import',
      refresh: 'Muat Semula',
      back: 'Kembali',
      next: 'Seterusnya',
      previous: 'Sebelumnya',
      confirm: 'Sahkan',
      yes: 'Ya',
      no: 'Tidak',
      loading: 'Memuatkan...',
      runBacktest: 'Jalankan Backtest',
      createStrategy: 'Bina Strategi Baru',
      testStrategy: 'Uji Strategi',
      saveStrategy: 'Simpan Strategi',
    },
    // Toast Messages
    toast: {
      success: 'Berjaya!',
      error: 'Ralat!',
      warning: 'Amaran!',
      info: 'Info',
      saved: 'Berjaya disimpan!',
      deleted: 'Berjaya dipadam!',
      updated: 'Berjaya dikemas kini!',
      copied: 'Disalin ke clipboard!',
      strategyCreated: 'Strategi berjaya disimpan!',
      backtestComplete: 'Backtest selesai!',
      checklistComplete: 'Checklist selesai untuk hari ini!',
      tradeAdded: 'Trade berjaya ditambah!',
      tradeDeleted: 'Trade berjaya dipadam!',
    },
    // Common Labels
    labels: {
      date: 'Tarikh',
      time: 'Masa',
      pair: 'Pair',
      type: 'Jenis',
      entry: 'Entry',
      exit: 'Exit',
      profit: 'Untung',
      loss: 'Rugi',
      pnl: 'P/L',
      balance: 'Baki',
      winRate: 'Win Rate',
      trades: 'Trades',
      session: 'Sesi',
      mood: 'Mood',
      notes: 'Nota',
      risk: 'Risiko',
      reward: 'Ganjaran',
      status: 'Status',
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      all: 'Semua',
      today: 'Hari Ini',
      yesterday: 'Semalam',
      thisWeek: 'Minggu Ini',
      thisMonth: 'Bulan Ini',
      days: 'Hari',
    },
    // Strategy Builder
    strategyBuilder: {
      title: 'Pembina Strategi',
      quickMode: 'Mod Pantas',
      fullMode: 'Mod Penuh',
      quickModeDesc: 'Uji cepat strategi dengan template siap pakai. Pilih rules dan lihat hasilnya serta-merta.',
      fullModeDesc: 'Bina strategi lengkap dengan syarat entry/exit, pengurusan risiko, dan simpan untuk kegunaan masa depan.',
      selectTemplate: 'PILIH TEMPLATE:',
      activeRules: 'RULES AKTIF',
      timeframe: 'TEMPOH:',
      savedStrategies: 'Strategi Tersimpan',
      noStrategies: 'Tiada strategi tersimpan',
      strategyName: 'NAMA STRATEGI',
      allowedSessions: 'SESI DIBENARKAN',
      riskPercent: 'RISIKO (%)',
      maxTrades: 'MAX TRADES/HARI',
      takeProfitPips: 'TAKE PROFIT (PIPS)',
      stopLossPips: 'STOP LOSS (PIPS)',
      entryRules: 'SYARAT ENTRY',
      exitRules: 'SYARAT EXIT/SKIP',
      addRule: 'Tambah',
      results: 'Hasil Backtest',
      originalPL: 'P/L ASAL',
      filteredPL: 'P/L FILTERED',
      improvement: 'IMPROVEMENT',
      excluded: 'DISKIP',
      profitFactor: 'PROFIT FACTOR',
      strategyEffective: 'Strategi Berkesan!',
      strategyIneffective: 'Strategi Kurang Berkesan',
      clearAndTest: 'Kosongkan & Uji Lagi',
    },
    // Premium Features
    premium: {
      title: 'Premium Features',
      subtitle: 'Unlock AI-powered features',
      active: 'Premium Active',
      upgrade: 'Upgrade Sekarang',
      priceMonth: '/bulan',
      signals: {
        title: 'AI Smart Signals',
        description: 'Isyarat trading AI dengan entry, SL, TP',
        generate: 'Jana Signals',
        generating: 'Menjana...',
        confidence: 'Keyakinan',
        entry: 'Entry Zone',
        stopLoss: 'Stop Loss',
        takeProfit: 'Take Profit',
        reasoning: 'Analisis AI',
        validFor: 'Sah untuk',
        hours: 'jam',
      },
      autopsy: {
        title: 'AI Trade Autopsy',
        description: 'Analisis mendalam setiap trade',
        selectTrade: 'Pilih trade untuk analisis',
        analyzing: 'Menganalisis...',
        verdict: 'Keputusan',
        grade: 'Gred',
        issues: 'Isu Ditemui',
        positives: 'Perkara Baik',
        recommendations: 'Cadangan',
        coachMessage: 'Mesej Coach',
      },
      telegram: {
        title: 'Telegram Bot',
        description: 'Alerts & notifikasi ke Telegram',
        connected: 'Bersambung!',
        notConnected: 'Belum bersambung',
        connect: 'Sambung',
        sendTest: 'Hantar Test',
        chatId: 'Chat ID',
        setup: 'Langkah Setup',
        notifications: 'Notifikasi',
      },
      lock: {
        locked: 'Dikunci',
        unlockWith: 'Buka dengan Premium',
        freeTrial: 'Pembayaran selamat dengan Stripe',
      },
    },
    // Email Report
    email: {
      title: 'Hantar Laporan',
      subtitle: 'Laporan mingguan ke email',
      address: 'Alamat Email',
      send: 'Hantar Laporan',
      sending: 'Menghantar...',
      sent: 'Email berjaya dihantar!',
      failed: 'Gagal menghantar email',
      includes: 'Laporan akan mengandungi:',
      weekSummary: 'Ringkasan minggu ini',
      winRatePL: 'Win rate & P/L',
      pairAnalysis: 'Analisis pair terbaik',
      aiTips: 'Tips dari AI',
    },
    // Sidebar Footer
    footer: {
      tagline: 'Earn in Dollar, Spend in Ringgit 💰',
    },
    // Language
    language: {
      toggle: 'Tukar Bahasa',
      bm: 'BM',
      en: 'EN',
    },
    // Market Movers
    marketMovers: {
      guideTitle: 'Panduan Market Movers',
      guideButton: 'Panduan',
      whatIs: 'Apa Itu Market Movers?',
      whatIsDesc: 'Market Movers adalah senarai <strong>trading pairs yang paling banyak bergerak</strong> dalam sesi semasa. Ia membantu anda mengenal pasti pairs yang mempunyai <strong class="text-green-400">momentum kuat</strong> untuk trading.',
      whatIsNote: 'Data real-time dari 15 major trading pairs • Auto-refresh setiap 5 minit',
      categories: 'Kategori Market Movers',
      topGainers: 'Top Gainers',
      topGainersDesc: 'Pairs dengan kenaikan % tertinggi - bullish momentum',
      topLosers: 'Top Losers',
      topLosersDesc: 'Pairs dengan penurunan % tertinggi - bearish momentum',
      mostVolatile: 'Most Volatile',
      mostVolatileDesc: 'Pairs dengan pergerakan terbesar - high activity',
      alignTitle: 'Cara Align dengan AI Signal',
      forBuy: 'UNTUK BUY SIGNAL:',
      forBuyDesc: 'Pilih pair dari',
      forBuyNote: 'Signal BUY + Bullish momentum = Higher win rate!',
      forSell: 'UNTUK SELL SIGNAL:',
      forSellDesc: 'Pilih pair dari',
      forSellNote: 'Signal SELL + Bearish momentum = Higher win rate!',
      avoid: 'ELAKKAN:',
      avoidBuy: 'BUY pair yang dalam Top Losers',
      avoidSell: 'SELL pair yang dalam Top Gainers',
      avoidNote: 'Anda akan trade AGAINST market momentum!',
      exampleFlow: 'Contoh Flow',
      generate: 'Generate',
      aiSignal: 'AI Signal',
      aligned: 'Aligned!',
      alignmentBonus: 'Signal + Momentum alignment = <span class="text-green-400 font-medium">+15% higher win rate</span>',
      closeButton: 'Faham! Tutup Panduan',
    },
  },
  en: {
    // Menu Items
    menu: {
      guide: 'Guide',
      checklist: 'Daily Checklist',
      dashboard: 'Dashboard',
      analytics: 'Analytics',
      strategy: 'Strategy Builder',
      achievements: 'Achievements',
      tools: 'Tools',
      journal: 'Journal',
      calculators: 'Calculator',
      ai: 'AI Analysis',
      education: 'Education',
      marketing: 'Marketing Angle',
      settings: 'Settings',
      polymarket: 'Polymarket Prediction',
    },
    // Dashboard
    dashboard: {
      title: 'Trading Overview',
      todayPnl: 'Today P/L',
      weeklyPnl: 'Weekly P/L',
      monthlyPnl: 'Monthly P/L',
      winRate: 'Win Rate',
      totalTrades: 'Total Trades',
      avgWin: 'Avg Win',
      avgLoss: 'Avg Loss',
      profitFactor: 'Profit Factor',
      bestPair: 'Best Pair',
      worstPair: 'Worst Pair',
      riskReward: 'Risk:Reward',
      drawdownStatus: 'Drawdown Status',
      drawdownSafe: 'Safe',
      drawdownWarning: 'Caution',
      drawdownDanger: 'Danger!',
      noTrades: 'No trades today',
      recentTrades: 'Recent Trades',
      weeklyChart: 'Weekly Performance',
      exportPdf: 'Export PDF',
      pdfGenerating: 'Generating PDF...',
      pdfReady: 'PDF Ready!',
    },
    // Analytics
    analytics: {
      title: 'Trading Analytics',
      sessionAnalysis: 'Session Analysis',
      emotionAnalysis: 'Emotion Analysis',
      pairAnalysis: 'Pair Analysis',
      equityCurve: 'Equity Curve',
      riskHeatmap: 'Risk Heatmap',
      bestSession: 'Best Session',
      worstSession: 'Worst Session',
      bestMood: 'Best Mood',
      worstMood: 'Worst Mood',
      recommendation: 'Recommendation',
      noData: 'Insufficient data for analysis',
      asia: 'Asia',
      london: 'London',
      newyork: 'New York',
      overlap: 'Overlap',
    },
    // Achievements
    achievements: {
      title: 'Achievements',
      subtitle: 'Collect badges and reach milestones!',
      unlocked: 'Unlocked',
      locked: 'Locked',
      progress: 'Progress',
      allBadges: 'All Badges',
      journalBadges: 'Journal',
      streakBadges: 'Streak',
      disciplineBadges: 'Discipline',
      profitBadges: 'Profit',
      accuracyBadges: 'Accuracy',
      recentUnlocks: 'Recent Unlocks',
      noBadges: 'No badges yet',
    },
    // Journal
    journal: {
      title: 'Trading Journal',
      addTrade: 'Add Trade',
      editTrade: 'Edit Trade',
      pair: 'Pair',
      type: 'Type',
      buy: 'BUY',
      sell: 'SELL',
      result: 'Result (USD)',
      date: 'Date',
      session: 'Session',
      mood: 'Mood',
      notes: 'Notes',
      noTrades: 'No trades in journal',
      deleteConfirm: 'Delete this trade?',
      importStatement: 'Import Statement',
      exportCsv: 'Export CSV',
    },
    // Moods
    moods: {
      tenang: 'Calm',
      fokus: 'Focused',
      takut: 'Fear',
      tamak: 'Greedy',
      revenge: 'Revenge',
      bosan: 'Bored',
    },
    // Sessions
    sessions: {
      asia: 'Asia',
      london: 'London',
      ny: 'New York',
    },
    // Calculators
    calculators: {
      title: 'Calculators',
      lotSize: 'Lot Calculator',
      pipValue: 'Pip Value',
      compounding: 'Compounding',
      breakeven: 'Break-Even',
      riskReward: 'Risk:Reward',
      accountBalance: 'Account Balance',
      riskPercent: 'Risk (%)',
      stopLoss: 'Stop Loss (pips)',
      lotResult: 'Lot Size',
      initialCapital: 'Initial Capital',
      monthlyReturn: 'Monthly Return (%)',
      months: 'Months',
      finalAmount: 'Final Amount',
      totalProfit: 'Total Profit',
      calculate: 'Calculate',
    },
    // AI Chat
    aiChat: {
      title: 'Fira AI',
      placeholder: 'Ask anything about trading...',
      send: 'Send',
      thinking: 'Thinking...',
      newChat: 'New Chat',
      clearHistory: 'Clear History',
      suggestions: 'Suggested Questions',
      analyzeXau: 'Analyze XAU/USD',
      analyzeEur: 'Analyze EUR/USD',
      checkSession: 'Check Session',
      reviewSetup: 'Review Setup',
      todayAnalysis: 'Today Analysis',
      weekReview: 'Week Review',
      whatWrong: 'What Went Wrong?',
    },
    // Education
    education: {
      title: 'Trading Education',
      basics: 'Trading Basics',
      technical: 'Technical Analysis',
      fundamental: 'Fundamental Analysis',
      psychology: 'Trading Psychology',
      riskManagement: 'Risk Management',
      articles: 'Articles',
      videos: 'Videos',
      comingSoon: 'Coming Soon',
    },
    // Checklist
    checklist: {
      title: 'Daily Checklist',
      completed: 'Completed!',
      streak: 'Streak',
      days: 'days',
      items: {
        news: 'Check economic calendar for high-impact news',
        review: 'Review yesterday trades & lessons',
        target: 'Set daily profit target & loss limit',
        risk: 'Confirm risk per trade (1-2% rule)',
        mental: 'Mental check - Am I ready to trade?',
        levels: 'Identify key support/resistance levels',
        session: 'Check active trading session (Asia/London/NY)',
      },
    },
    // Weekly Report
    weeklyReport: {
      title: 'Weekly Report',
      period: 'Period',
      totalTrades: 'Total Trades',
      winTrades: 'Winning Trades',
      lossTrades: 'Losing Trades',
      winRate: 'Win Rate',
      totalPnl: 'Total P/L',
      bestPair: 'Best Pair',
      worstPair: 'Worst Pair',
      moodAnalysis: 'Mood Analysis',
      sessionAnalysis: 'Session Analysis',
      sendEmail: 'Send Email',
      emailSent: 'Email sent!',
      emailFailed: 'Failed to send email',
    },
    // PDF Export
    pdfExport: {
      title: 'Export PDF Report',
      generating: 'Generating PDF...',
      download: 'Download PDF',
      include: 'Include in report:',
      summary: 'Trading Summary',
      trades: 'Trade List',
      analytics: 'Analytics',
      charts: 'Charts',
    },
    // Header
    header: {
      title: 'Fira Smart Desk AI',
      subtitle: 'Built to analyze. Designed to decide.',
      usdMyr: 'USD / MYR',
    },
    // Bottom Nav
    bottomNav: {
      tools: 'Tools',
      journal: 'Journal',
      premium: 'Signal',
      badges: 'Badges',
      menu: 'Menu',
    },
    // Common Buttons
    buttons: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      submit: 'Submit',
      clear: 'Clear',
      reset: 'Reset',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      loading: 'Loading...',
      runBacktest: 'Run Backtest',
      createStrategy: 'Create New Strategy',
      testStrategy: 'Test Strategy',
      saveStrategy: 'Save Strategy',
    },
    // Toast Messages
    toast: {
      success: 'Success!',
      error: 'Error!',
      warning: 'Warning!',
      info: 'Info',
      saved: 'Successfully saved!',
      deleted: 'Successfully deleted!',
      updated: 'Successfully updated!',
      copied: 'Copied to clipboard!',
      strategyCreated: 'Strategy saved successfully!',
      backtestComplete: 'Backtest complete!',
      checklistComplete: 'Checklist complete for today!',
      tradeAdded: 'Trade added successfully!',
      tradeDeleted: 'Trade deleted successfully!',
    },
    // Common Labels
    labels: {
      date: 'Date',
      time: 'Time',
      pair: 'Pair',
      type: 'Type',
      entry: 'Entry',
      exit: 'Exit',
      profit: 'Profit',
      loss: 'Loss',
      pnl: 'P/L',
      balance: 'Balance',
      winRate: 'Win Rate',
      trades: 'Trades',
      session: 'Session',
      mood: 'Mood',
      notes: 'Notes',
      risk: 'Risk',
      reward: 'Reward',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      all: 'All',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      days: 'Days',
    },
    // Strategy Builder
    strategyBuilder: {
      title: 'Strategy Builder',
      quickMode: 'Quick Mode',
      fullMode: 'Full Mode',
      quickModeDesc: 'Quick test strategies with ready-made templates. Select rules and see results instantly.',
      fullModeDesc: 'Build complete strategies with entry/exit conditions, risk management, and save for future use.',
      selectTemplate: 'SELECT TEMPLATE:',
      activeRules: 'ACTIVE RULES',
      timeframe: 'TIMEFRAME:',
      savedStrategies: 'Saved Strategies',
      noStrategies: 'No saved strategies',
      strategyName: 'STRATEGY NAME',
      allowedSessions: 'ALLOWED SESSIONS',
      riskPercent: 'RISK (%)',
      maxTrades: 'MAX TRADES/DAY',
      takeProfitPips: 'TAKE PROFIT (PIPS)',
      stopLossPips: 'STOP LOSS (PIPS)',
      entryRules: 'ENTRY CONDITIONS',
      exitRules: 'EXIT/SKIP CONDITIONS',
      addRule: 'Add',
      results: 'Backtest Results',
      originalPL: 'ORIGINAL P/L',
      filteredPL: 'FILTERED P/L',
      improvement: 'IMPROVEMENT',
      excluded: 'SKIPPED',
      profitFactor: 'PROFIT FACTOR',
      strategyEffective: 'Strategy is Effective!',
      strategyIneffective: 'Strategy is Ineffective',
      clearAndTest: 'Clear & Test Again',
    },
    // Premium Features
    premium: {
      title: 'Premium Features',
      subtitle: 'Unlock AI-powered features',
      active: 'Premium Active',
      upgrade: 'Upgrade Now',
      priceMonth: '/month',
      signals: {
        title: 'AI Smart Signals',
        description: 'AI trading signals with entry, SL, TP',
        generate: 'Generate Signals',
        generating: 'Generating...',
        confidence: 'Confidence',
        entry: 'Entry Zone',
        stopLoss: 'Stop Loss',
        takeProfit: 'Take Profit',
        reasoning: 'AI Analysis',
        validFor: 'Valid for',
        hours: 'hours',
      },
      autopsy: {
        title: 'AI Trade Autopsy',
        description: 'Deep analysis of each trade',
        selectTrade: 'Select trade to analyze',
        analyzing: 'Analyzing...',
        verdict: 'Verdict',
        grade: 'Grade',
        issues: 'Issues Found',
        positives: 'What You Did Well',
        recommendations: 'Recommendations',
        coachMessage: 'Coach Message',
      },
      telegram: {
        title: 'Telegram Bot',
        description: 'Alerts & notifications to Telegram',
        connected: 'Connected!',
        notConnected: 'Not connected',
        connect: 'Connect',
        sendTest: 'Send Test',
        chatId: 'Chat ID',
        setup: 'Setup Steps',
        notifications: 'Notifications',
      },
      lock: {
        locked: 'Locked',
        unlockWith: 'Unlock with Premium',
        freeTrial: 'Secure payment with Stripe',
      },
    },
    // Email Report
    email: {
      title: 'Send Report',
      subtitle: 'Weekly report to email',
      address: 'Email Address',
      send: 'Send Report',
      sending: 'Sending...',
      sent: 'Email sent successfully!',
      failed: 'Failed to send email',
      includes: 'Report will include:',
      weekSummary: 'This week\'s summary',
      winRatePL: 'Win rate & P/L',
      pairAnalysis: 'Best pair analysis',
      aiTips: 'AI tips',
    },
    // Sidebar Footer
    footer: {
      tagline: 'Earn in Dollar, Spend in Ringgit 💰',
    },
    // Language
    language: {
      toggle: 'Change Language',
      bm: 'BM',
      en: 'EN',
    },
    // Market Movers
    marketMovers: {
      guideTitle: 'Market Movers Guide',
      guideButton: 'Guide',
      whatIs: 'What is Market Movers?',
      whatIsDesc: 'Market Movers is a list of <strong>trading pairs with the highest movement</strong> in the current session. It helps you identify pairs with <strong class="text-green-400">strong momentum</strong> for trading.',
      whatIsNote: 'Real-time data from 15 major trading pairs • Auto-refresh every 5 minutes',
      categories: 'Market Movers Categories',
      topGainers: 'Top Gainers',
      topGainersDesc: 'Pairs with highest % increase - bullish momentum',
      topLosers: 'Top Losers',
      topLosersDesc: 'Pairs with highest % decrease - bearish momentum',
      mostVolatile: 'Most Volatile',
      mostVolatileDesc: 'Pairs with largest movement - high activity',
      alignTitle: 'How to Align with AI Signal',
      forBuy: 'FOR BUY SIGNAL:',
      forBuyDesc: 'Choose pair from',
      forBuyNote: 'BUY Signal + Bullish momentum = Higher win rate!',
      forSell: 'FOR SELL SIGNAL:',
      forSellDesc: 'Choose pair from',
      forSellNote: 'SELL Signal + Bearish momentum = Higher win rate!',
      avoid: 'AVOID:',
      avoidBuy: 'BUY pairs in Top Losers',
      avoidSell: 'SELL pairs in Top Gainers',
      avoidNote: 'You will trade AGAINST market momentum!',
      exampleFlow: 'Example Flow',
      generate: 'Generate',
      aiSignal: 'AI Signal',
      aligned: 'Aligned!',
      alignmentBonus: 'Signal + Momentum alignment = <span class="text-green-400 font-medium">+15% higher win rate</span>',
      closeButton: 'Got it! Close Guide',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('fira-language');
    if (saved) return saved;
    // Auto-detect from browser for first-time users
    const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (browserLang.startsWith('ms') || browserLang.startsWith('my')) return 'bm';
    return 'en'; // Default EN for worldwide users
  });

  useEffect(() => {
    localStorage.setItem('fira-language', language);
    // Sync language preference to backend (for Telegram, email, etc.)
    const token = localStorage.getItem('token');
    if (token) {
      const API = process.env.REACT_APP_BACKEND_URL || '';
      fetch(`${API}/api/user/language`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ language })
      }).catch(() => {}); // Silent fail — non-critical
    }
  }, [language]);

  const t = (key) => {
    if (!key || typeof key !== 'string') {
      return key || '';
    }
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'bm' ? 'en' : 'bm');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, isBM: language === 'bm', isEnglish: language === 'en' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
